<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                items: [],
            }"
            :filters-default="{
                status_id: '',
                order_date: '',
            }"
            :filter-items="[
                {
                    vModel: 'status_id',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '出荷待ち', value: '50' },
                        { text: 'キャンセル', value: '-1' },
                        { text: '処理中', value: '20' },

                        { text: trans.labels['shipping_crobo.status.30'], value: '30' },
                        { text: trans.labels['shipping_crobo.status.31'], value: '31' },
                        { text: trans.labels['shipping_crobo.status.32'], value: '32' },
                        { text: trans.labels['shipping_crobo.status.33'], value: '33' },
                        { text: trans.labels['shipping_crobo.status.34'], value: '34' },
                        { text: trans.labels['shipping_crobo.status.40'], value: '40' },
                        { text: trans.labels['shipping_crobo.status.80'], value: '80' },
                        { text: trans.labels['shipping_crobo.status.55'], value: '55' },
                        { text: trans.labels['shipping_crobo.status.90'], value: '90' },
                        { text: trans.labels['shipping_crobo.status.100'], value: '100' },
                    ],
                },
                {
                    vModel: 'order_date',
                    title: '注文日',
                    type: 'date-range',
                    options: {
                        force_range: false,
                    },
                },
            ]"
            filters-q-placeholder="PEC"
            form-modal-id="shipping_crobo_order"
            search-action="shipping_crobo_order/index"
            :filter-search-results="filterSearchResults"
            row-class="flex-nowrap mx-0 my--2"
            :hide-table="true"
            :open-detail-after-saving="false"
            item-id="id"
            @after-save="afterSave"
            @after-destroy="afterDestroy"
            >
            <template v-slot:form="{ form, init }">
                <ShippingCroboOrder :model="form" :init="init" @save="$refs.gridPage.save" @destroy="$refs.gridPage.destroy" filter_courier="ecms"></ShippingCroboOrder>
            </template>

            <template v-slot:search-prepend>
                <b-input-group-prepend
                    v-if="$refs.gridPage"
                    >
                    <SelectUserMarunage
                        v-model="$refs.gridPage.grid.filters.marunage_user_id"
                        />
                </b-input-group-prepend>
            </template>

            <template v-slot:before-table="{ response }">
                <b-table-simple
                    hover small caption-top bordered
                    class="mt-3"
                    >
                    <b-thead>
                        <b-tr>
                            <b-th>操作</b-th>
                            <b-th>注文番号</b-th>
                            <b-th>注文ID</b-th>
                            <b-th>注文日</b-th>
                            <b-th>ステータス</b-th>
                            <b-th>出荷日</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody
                        v-if="response && response.data"
                        >
                        <b-tr
                            v-for="(item, index) in response.data.hits"
                            :key="item.order_id"
                            >
                            <b-td>
                                <b-dropdown
                                    variant="link"
                                    toggle-class="text-decoration-none p-0"
                                    no-caret
                                    >
                                    <template #button-content>
                                        <a>操作</a>
                                    </template>
                                    <b-dropdown-item href="#" @click="action(item, 'cancel')"><span class="text-danger">キャンセル</span></b-dropdown-item>
                                    <template v-if="auth_level === '300'">
                                        <b-dropdown-item href="#" @click="action(item, 'delete')"><span class="text-danger">削除</span></b-dropdown-item>
                                    </template>
                                </b-dropdown>
                            </b-td>
                            <b-td>
                                {{ item.order_no }}
                            </b-td>
                            <b-td>
                                {{ item.order_id }}
                            </b-td>
                            <b-td>
                                {{ item.order_date }}
                            </b-td>
                            <b-td>
                                <template v-if="item.cancel_flag === '1'">
                                    キャンセル
                                </template>
                                <template v-else>
                                        {{
                                        trans.labels[
                                        'shipping_crobo.status.' + item.status_id
                                        ]
                                        }}
                                </template>
                            </b-td>
                            <b-td>
                                {{ item.shipping_date }}
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </template>

            <template v-slot:after-table>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import ShippingCroboOrder from '@/components/ShippingCroboOrder.vue'
import ShippingBadges from '@/components/ShippingBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'
import ShippingEcmsTable from '@/components/ShippingEcmsTable.vue'
import SelectUserMarunage from '@/components/SelectUserMarunage.vue'

export default {
    components: {
        GridPage,
        ShippingCroboOrder,
        ShippingBadges,
        ItemThumb,
        ItemInfo,
        ShippingEcmsTable,
        SelectUserMarunage,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_user',
            'trans',
        ])
    },
    data() {
        return {}
    },
    async mounted() {
        if (this.auth_user) {
            for (let i = 0; i < this.auth_user.group.length; i++) {
                if (this.auth_user.group[i].marunage_user_id) {
                    this.$utils.set(
                        this.$refs.gridPage.grid.filters,
                        {
                            marunage_user_id: this.auth_user.group[i].marunage_user_id,
                        }
                    )
                    break
                }
            }
        }
    },
    methods: {
        filterSearchResults(response) {
            return response
        },
        afterSave() {
            this.$store.dispatch('notification/push', { color: 'success', text: '保存処理を受け付けました。処理はバックグラウンドで実行されます。保存完了まで 数分程度かかる場合があります。', })
            this.$refs.gridPage.search()
        },
        afterDestroy() {
            this.$refs.gridPage.search()
        },
        onDetail(item) {
            this.$refs.gridPage.detail(item)
        },
        async action(item, type) {
            let message = ''
            let verb = ''
            switch (type) {
                case 'cancel':
                    message = '本当にキャンセルしてもよろしいでしょうか？'
                    verb = 'キャンセル'
                    break
                case 'delete':
                    message = '本当に削除してもよろしいでしょうか？'
                    verb = '削除'
                    break
            }
            if (message) {
                const result = await this.$utils.modalConfirm(
                    this,
                    '確認',
                    message,
                    {
                        okVariant: 'danger',
                        okTitle: verb + 'する',
                        cancelTitle: verb + 'しない',
                    }
                )
                if (!result) {
                    return
                }
            }
            const response = await this.$store
                .dispatch('shipping_crobo_order/action', {
                    order_id: item.order_id,
                    order_no: item.order_no,
                    action: type,
                })
                .then((response) => {
                    if (type !== 'download_attach') {
                        this.$refs.gridPage.search()
                    }
                })
        },
    },
}
</script>

